import {Component} from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {CompoMovimentazione} from "../stato-movimentazioni.component";
import {DiscrepanzaDetailsApiDescriptor, MagazzinoApiDescriptor, ModelloDispositivoApiDescriptor, ScuolaPraticaApiDescriptor, StatoDiscrepanza} from "../../../../models/magazzino.model";
import {MessageService, SelectItem} from "primeng/api";
import {Impresa} from "../../../../models/impresa.model";
import {MagazzinoService} from "../../../../services/magazzino.service";

@Component({
  selector: 'app-inconsistency-resolution-dialog',
  templateUrl: './inconsistency-resolution-dialog.component.html',
  styleUrls: ['./inconsistency-resolution-dialog.component.scss']
})
export class InconsistencyResolutionDialogComponent {

	protected readonly StatoDiscrepanza = StatoDiscrepanza;

	dataReady: boolean;
	discrepanza: DiscrepanzaDetailsApiDescriptor;

	edit_stato: StatoDiscrepanza;
	edits_materiali: {
		modello:		ModelloDispositivoApiDescriptor,
		qt:				number;
	}[];

	materialiById: {[key: string]: {
		id:				string,
		info:			ModelloDispositivoApiDescriptor,
		srcdelta:		number;
	}};

	opzioniAzioneStato: SelectItem<StatoDiscrepanza>[] = [
		{ label: "NON CONFERMATA", value: StatoDiscrepanza.NONCONFERMATA },
		{ label: "RISOLTA CON CORRETTIVO", value: StatoDiscrepanza.RISOLTA }
	];

	hasValidForm: boolean;
	fixIsPartial: boolean;

	constructor(
		public dialogService: DialogService,
		public ref: DynamicDialogRef,
		public config: DynamicDialogConfig<{
			src: CompoMovimentazione;
			magazzini: MagazzinoApiDescriptor[];
			imprese: Impresa[];
			materiali: ModelloDispositivoApiDescriptor[];
			scuole: ScuolaPraticaApiDescriptor[];
		}>,
		private messages: MessageService,
		private magazzinoBackend: MagazzinoService
	) {
		this.dataReady = false;
		this.loadData();
	}

	loadData () {
		const did = this.config.data.src.discrepanza?.id ?? null;

		const matdesc = Object.fromEntries(this.config.data.materiali.map((item) => {
			return [item.id, item];
		}));

		this.magazzinoBackend.discrepanzaGet(did).subscribe((result) => {
			this.discrepanza = result.item;
			console.log(this.discrepanza);
			this.materialiById = {};
			for (let mat of this.discrepanza.materiali) {
				this.materialiById[mat.id] = {
					id: mat.id,
					info: matdesc[mat.id],
					srcdelta: -mat.delta
				}
			}

			this.edit_stato = StatoDiscrepanza.NONCONFERMATA;
			this.edits_materiali = this.discrepanza.materiali.map((item) => {
				return {
					modello: this.materialiById[item.id].info,
					qt: this.materialiById[item.id].srcdelta
				}
			});
			this.dataReady = true;
			this.validateForm();
		})
	}

	validateForm () {
		// either cancel it or needs to have SOME materials
		this.hasValidForm = this.edit_stato == StatoDiscrepanza.NONCONFERMATA || this.edits_materiali.some((item) => {
			return item.qt > 0;
		});
		this.fixIsPartial = this.edit_stato == StatoDiscrepanza.RISOLTA && this.edits_materiali.some((item) => {
			return item.qt != this.materialiById[item.modello.id].srcdelta
		})
	}

	onActivityCompleted (confirm: boolean) {

		let result = null;
		if (confirm) {
			result = {
				state: this.edit_stato,
				materials: this.edit_stato == StatoDiscrepanza.RISOLTA ? this.edits_materiali.map((item) => {
					return {
						id: item.modello.id,
						qt: item.qt
					}
				}) : null
			}
		}
		this.ref.close(result);
	}
}

export interface InconsistencyResolution {
	state:		StatoDiscrepanza,
	materials?:	{
		id:		string;
		qt:		number;
	}[]
}